module.exports = __webpack_public_path__ + "static/media/XJ.bcb7662f.png";